module.exports = __webpack_public_path__ + "static/ae1-aa8d2eaa41f452aee8157b6aa86d3633.svg";